import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=7749cc8c&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=js&"
export * from "./SimpleModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SimpleModal.vue?vue&type=style&index=1&id=7749cc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7749cc8c",
  null
  
)

export default component.exports